import { Injectable } from '@angular/core';
import {MatSnackBar, MatSnackBarRef, MatSnackBarConfig} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private snackBar: MatSnackBar) { }

  public success(message: string, action?: string): MatSnackBarRef<any> {
    return this.snackBar.open(message, action, {
      ...this.config(5000),
      panelClass: ['success', 'pl-notification']
    });
  }

  public info(message: string, action?: string): MatSnackBarRef<any> {
    return this.snackBar.open(message, action, {
      ...this.config(5000),
      panelClass: ['info', 'pl-notification']
    });
  }

  public warn(message: string, action?: string): MatSnackBarRef<any> {
    return this.snackBar.open(message, action, {
      ...this.config(10000),
      panelClass: ['warn', 'pl-notification']
    });
  }

  /**
   * Compact confirmation that closes itself, without an action button (e.g. "Código copiado").
   * Styled only by `.pl-brief-toast`, so the other snackbars keep their own panel classes.
   */
  public brief(message: string, duration: number = 1800): MatSnackBarRef<any> {
    return this.snackBar.open(message, undefined, {
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['pl-brief-toast']
    });
  }

  public error(message: string, action?: string): MatSnackBarRef<any> {
    return this.snackBar.open(message, action, {
      ...this.config(10000),
      panelClass: ['error', 'pl-notification']
    });
  }

  private config(duration: number): MatSnackBarConfig {
    return {
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    }
  }
}
